import React, { useState, useEffect } from 'react';
import './TestimonialSlider.css';

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      name: "Ahmed Mansour",
      role: "Operations Director, Telecorp",
      content: "MTPRO filled critical gaps in our infrastructure project that saved us months of delays. Their 25 years of experience really shows in their problem-solving.",
    },
    {
      id: 2,
      name: "Sara El-Sayed",
      role: "Lead Engineer, PetroGate",
      content: "As a single point of contact, they made the integration between engineering and commissioning seamless. Truly a professional project management partner.",
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const companies = [
    "Arab International Optic Company",
    "Engineering Co. For The Petroleum & Process Industries (ENPPI)",
    "Education Development Fund",
    "The Egyptian Ethylene and Derivatives Company (ETHEDCO)",
    "Etisalat Misr",
    "Information and Communication Technology project (ICTP)",
    "Egyptian Styrene & Polystyrene Production Company",
    "Alexandria International Container Terminals (AICT)",
    "Aviation Information Technology Company",
    "Holding Pharma Group",
    "Egyptian Airports Company",
    "Egyptair Company",
    "Egyptian Environmental Affairs Agency (EEAA)",
    "Virtual Management Inc. (USA)",
    "Ministry of Defense (Officers Affairs Department)",
    "Elafandi Establishment (Kingdom of Saudi Arabia)",
    "Arabian Gulf University (Bahrain)",
    "Saudi Amoudi Group (Kingdom of Saudi Arabia)",
    "Arab Contractors Company",
    "Suez Canal Authority",
    "Investments Residential projects (Kuwait)",
    "International Corporation of Development (ICD) for Private Sector",
    "Ministry of Supply and Foreign Trade",
    "United Nations Development Program (UNDP)",
    "Ministry of Industry & Technological Development",
    "European Privatization Program",
    "El-Sewedy Investment & Industries Group",
    "Elsewedy-Hanjung (Joint Venture)",
    "Operations Research Center",
    "Arab Authority for Agricultural Investment and Development (Sudan)",
  ];

  const nextSlide = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  // Auto-play functionality - continuous loop
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        // Loop back to first slide after last slide
        return (prev + 1) % testimonials.length;
      });
    }, 8000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [testimonials.length]);

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="quote-mark">"</div>
        
        <div className="testimonial-content-wrapper">
          {testimonials.map((item, index) => (
            <div 
              key={item.id} 
              className={`testimonial-slide ${index === activeIndex ? 'active' : ''}`}
            >
              <p className="testimonial-text">{item.content}</p>
              
              <div className="testimonial-author">
                <div className="author-info">
                  <h4 className="author-name">{item.name}</h4>
                  <p className="author-role">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Company Logo Slider */}
      <div className="companies-section">
        <div className="companies-label">Companies We Work With</div>
        <div className="companies-slider-wrapper">
          <div className="companies-slider">
            {[...companies, ...companies, ...companies, ...companies].map((company, index) => (
              <div key={index} className="company-item">
                <span className="company-name">{company}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;
